import { S3_URL } from 'constants';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { Stack, Button } from 'react-bootstrap';
import parse from 'html-react-parser';

const RecordCard: React.FC<any> = ({
	data,
	id = null,
	onShowModal,
	type = '',
	dateStyle = {},
	descriptionStyle = {},
	isSelf = false,
	showDeleteModal,
	deleteKey = '',
}) => {
	const { image, title, subtitle, date, description, isImage = false } = data;
	return (
		<div key={`${type}-${id}`} className="gray-box d-flex flex-1 position-relative gap-4">
			<div className="d-flex flex-column flex-md-row gray-box-inner flex-1">
				{isImage && (
					<div className="gray-box-logo bg-white">
						<img
							src={image ? `${S3_URL}${image}` : IMAGE_PATHS.BrandLogo4}
							alt="logo"
							className="w-100 h-100 object-fit-cover"
							loading="lazy"
						/>
					</div>
				)}
				<Stack className="gray-box-info-content gap-2 justify-content-center flex-1">
					{title && <h4 className="fw-bold mb-0">{title}</h4>}
					{subtitle && <p className="mb-0">{subtitle}</p>}
					{date && (
						<p className="mb-0" style={dateStyle}>
							{date}
						</p>
					)}
					{description && (
						<p className="mb-0" style={descriptionStyle}>
							{parse(description.replace(/\n/g, '<br>'))}
						</p>
					)}
				</Stack>
			</div>
			{isSelf && (
				<Stack className="gray-box-actions" gap={2} style={{ flex: 'none' }}>
					<Button
						className="edit-btn rounded-circle p-0 border-0 bg-white"
						onClick={() => showDeleteModal(type, deleteKey, id)}
					>
						<i className="ri-delete-bin-line"></i>
					</Button>

					<Button
						className="edit-btn rounded-circle p-0 border-0 bg-white"
						onClick={() => onShowModal(type, id)}
					>
						<i className="ri-edit-line"></i>
					</Button>
				</Stack>
			)}
		</div>
	);
};

export default RecordCard;
